const tokenName = document
    .querySelector('[name="csrf-param"]')
    .getAttribute('content');
const tokenValue = document
    .querySelector('[name="csrf-token"]')
    .getAttribute('content');

export default class CSRF {
    static get tokenName() {
        return tokenName;
    }

    static get tokenValue() {
        return tokenValue;
    }

    static getByObject() {
        const result = {};

        result[tokenName] = tokenValue;

        return result;
    }
}
